"use strict";

exports.__esModule = true;
exports.__TEST__ = exports.__DEV__ = void 0;
exports.isArray = isArray;
exports.isEmpty = isEmpty;
exports.isEmptyArray = isEmptyArray;
exports.isEmptyObject = isEmptyObject;
exports.isObject = isObject;

const __DEV__ = process.env.NODE_ENV !== 'production';

exports.__DEV__ = __DEV__;

const __TEST__ = process.env.NODE_ENV === 'test';

exports.__TEST__ = __TEST__;

function isArray(value) {
  return Array.isArray(value);
}

function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}

function isObject(value) {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function') && !isArray(value);
}

function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
} // Empty assertions


function isEmpty(value) {
  if (isArray(value)) return isEmptyArray(value);
  if (isObject(value)) return isEmptyObject(value);
  if (value == null || value === '') return true;
  return false;
}